/**
 * Extracts error message from error object.
 * @param error
 */
export const extractErrorMessage = (error) =>
  error ? Object.values(error).join(' ') : '';



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/extractErrorMessage.js